import { EVENTS } from '../config/productInsights';
import { createProductInsights } from '../config/productInsightsRuntime';
import { getAnalyticsConsentRevision, isAnalyticsActive, trackEvent } from './gaEvents';

export { EVENTS };
const runtime = createProductInsights({ getAnalyticsConsentRevision, isAnalyticsActive, trackEvent });
export function insight(event: string, params: Record<string, unknown> = {}): void {
  runtime.insight(event, params);
}
export function observeProductRequest<T>(url: string, body: unknown, run: () => Promise<T>, stream = false): Promise<T> {
  return runtime.observeProductRequest(url, body, run, stream) as Promise<T>;
}
